module.exports = __webpack_public_path__ + "img/6d6ca89d-fbc2-4fc2-93d0-6ee46ae97345.731dc060.jpg";